

import AudioVisualizer from "../UI/AudioVisualizer";
import "./visualizer.css";
export function UserVideo({ videoRef, audioStatus }) {
  return (
    <div
      //  className="md:w-[300px] md:h-[300px] lg:w-[320px] lg:h-[320px] w-[180px] h-[180px] absolute top-3 right-3"
      className="w-full min-h-[50vh] z-40"
    >
      <div className="w-full h-full relative">
        {/* <Tooltip
          id="videorecordtooltip"
          position="bottom"
          content="Your video is appeared here."> */}
        <video
          ref={videoRef}
          className=" rounded-2xl w-full h-[50vh]  object-cover"
          autoPlay
          playsInline
        ></video>
        {/* </Tooltip> */}
        {/* Sound Wave Component  */}
        {true && (
          <div className="w-[30px] h-[30px] rounded-full absolute bottom-[5px] right-[3px] flex flex-row items-center justify-center">
            {/* <BsSoundwave className="w-[15px] h-[15px] text-white p-0" /> */}
            <AudioVisualizer start={audioStatus} />
          </div>
        )}
      </div>
    </div>
  );
}
